<template>
    <div class="g pop-up-inner">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            :caption="$t('popup.aboutus.caption.aboutus')"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <div class="g">
                    <div class="md minor-table">
                        <table>
                            <tbody>
                                <tr>
                                    <th><label>{{ $t('popup.aboutus.item.version') }}</label></th>
                                    <td>{{ version }} (Official Build) (64-bit) </td>
                                </tr>
                                <tr>
                                    <th><label>{{ $t('popup.aboutus.item.support') }}</label></th>
                                    <td>{{ $t('popup.aboutus.item.supportdetail') }}</td>
                                </tr>
                                <tr>
                                    <th><label>{{ $t('popup.aboutus.item.service') }}</label></th>
                                    <td>{{ $t('popup.aboutus.item.servicedetail') }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            align="center"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </div>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import cpStatus from '@/components/cpStatus'
    import cpLabel from '@/components/cpLabel'
    import mdBtnList from '@/components/mdBtnList'

    import { mapMutations, mapState } from 'vuex'

    export default {
        components: {
            mdCaption,
            mdToggleAside,
            cpStatus,
            cpLabel,
            mdBtnList,
        },
        props: {
            sn: {
                require: true
            },
        },
        computed: {
            ...mapState([
                'version',
            ]),
            btns: function(){
                let $cancel = {
                        text:this.$t('site.func.popupclose'),
                        func: 'close',
                    },
                    $colorSet = {
                        text: '版面顏色設定',
                        themes: 'info',
                        func: 'colorSet',
                    }

                let $results = [
                        $colorSet,
                        $cancel,
                    ]

                return $results;
            },
        },
        methods: {
            ...mapMutations([
                'pushPopUp',
                'pushNotification'
            ]),
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            },
            colorSet: function(){
                this.pushPopUp({
                    type: 'colorSet',
                    content: {
                        callback: () => {

                            this.pushNotification({
                                type: 'notification',
                                content: {
                                    html: this.$t('site.status.updatesucess'),
                                }
                            });

                            this.close();
                        }
                    }
                });
            }
        }
    }
</script>

<style scoped lang="scss">

    .member-title {
        vertical-align: top;

        .cp.status {
            white-space: nowrap;
        }
    }

    .member-data {
        display: inline-block;

        &:after {
            content: '、'
        }

        &:last-child {

            &:after {
                content: none
            }
        }
    }

    .member-table {

        th {
            text-align: left;
            font-weight: normal;
        }
    }
</style>
